import { render } from "./AuthLayoutRedesign.vue?vue&type=template&id=7392e242&scoped=true"
const script = {}

import "./AuthLayoutRedesign.vue?vue&type=style&index=0&id=7392e242&lang=scss&scoped=true"

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7392e242"],['__file',"src/layouts/AuthLayoutRedesign.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7392e242"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7392e242', __exports__)) {
    api.reload('7392e242', __exports__)
  }
  
  module.hot.accept("./AuthLayoutRedesign.vue?vue&type=template&id=7392e242&scoped=true", () => {
    api.rerender('7392e242', render)
  })

}


export default __exports__